import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

// Role Continuous Learning deep-link params: an inbox row for a proposed role
// improvement links to /company/roles?role=<roleId>&improvement=<additionId> so
// the role drawer opens focused on that proposal. Both are optional; unrelated
// visits validate to undefined and are byte-identical.
interface RolesSearch {
  role?: string;
  improvement?: string;
}

export const Route = createFileRoute('/_authenticated/company/roles')({
  beforeLoad: requireOrgAdminBeforeLoad,
  validateSearch: (search: Record<string, unknown>): RolesSearch => ({
    role: typeof search.role === 'string' ? search.role : undefined,
    improvement:
      typeof search.improvement === 'string' ? search.improvement : undefined,
  }),
}).lazy(() => import('./roles.lazy').then((d) => d.Route));
